const apiPath = '/api/app';

export const createCartRequest = async () => {
  const response = await fetch(`${apiPath}/carts`, {
    method: 'POST'
  })

  if (response.status === 201) {
    return await response.json();
  } else {
    return {data: null};
  }
};

export const getCart = async (cart) => {
  if (!cart) return {data: null};

  const response = await fetch(`${apiPath}/carts/${cart.id}?token=${cart.token}`, {
    method: 'GET'
  })

  if (response.status === 200) {
    return await response.json();
  } else {
    return {data: null};
  }
};

export const getDeliveryMethods = async () => {
  const response = await fetch(`${apiPath}/delivery_methods`, {
    method: 'GET'
  })

  if (response.status === 200) {
    return await response.json();
  } else {
    return {items: []};
  }
};

export const getPaymentServices = async () => {
  const response = await fetch(`${apiPath}/payment_services`, {
    method: 'GET'
  })

  if (response.status === 200) {
    return await response.json();
  } else {
    return {items: []};
  }
};

export const updateCart = async (cartId, payload) => {
  return await fetch(`${apiPath}/carts/${cartId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
};

export const createCartItem = async (cart, productId, quantity = 1) => {
  if (!cart) return {status: 404};

  return await fetch(`${apiPath}/carts/${cart.id}/cart_items`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      product_id: productId,
      token: cart.token,
      quantity: quantity
    })
  }).then(handleResponse)
}

export const updateItem = async (id, itemId, payload) => {
  return await fetch(`${apiPath}/carts/${id}/cart_items/${itemId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
};

export const removeItem = async (id, itemId, token) => {
  return fetch(`${apiPath}/carts/${id}/cart_items/${itemId}?token=${token}`, {
    method: 'DELETE'
  })
};

export const handleResponse = async (response) => {
  const contentType = response.headers.get("content-type");

  if (contentType && contentType.indexOf("application/json") !== -1) {
    const data = await response.json();
    return await { status: response.status, ...data };
  } else {
    return await { status: response.status };
  }
};

export const showErrors = (error) => {
  try {
    let rsp = JSON.parse(error.message);
    console.log(rsp);
  } catch(e) {
    alert(error.message);
  }
}
